module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topicColumnDetail"
    }
  }, [(!_vm.isShare) ? _c('topBanner', {
    attrs: {
      "appName": _vm.appName,
      "detail": 1
    },
    on: {
      "topicDetail": _vm.topicDetail
    }
  }) : _vm._e(), _vm._v(" "), (_vm.discussDetail) ? _c('discussDetail', {
    attrs: {
      "discussItem": _vm.discussDetail,
      "isDetail": 1
    },
    on: {
      "showSwiper": _vm.showSwiper
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "topicDetailComments"
  }, [(_vm.isHotShow && _vm.hotComments) ? _c('hot-comments', {
    attrs: {
      "hotComments": _vm.hotComments,
      "govImage": _vm.govImage,
      "themeColor": _vm.themeColor
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLastShow && _vm.lastComments) ? _c('last-comments', {
    attrs: {
      "lastComments": _vm.lastComments,
      "govImage": _vm.govImage,
      "themeColor": _vm.themeColor
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.isHotShow === false && _vm.isLastShow === false) ? _c('div', {
    staticClass: "noComments"
  }, [_c('svg', {
    staticStyle: {
      "width": "0.68rem",
      "height": "0.68rem"
    },
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "viewBox": "0 0 68 68"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "fill": "rgb(221, 221, 221)",
      "d": "M59.304,58.292 L61.874,60.866 C63.383,62.376 63.627,64.580 62.422,65.787 C61.213,66.998 59.013,66.753 57.505,65.243 L52.040,59.769 C52.036,59.765 52.033,59.760 52.028,59.755 C51.460,59.185 50.694,58.858 49.889,58.847 L17.886,58.847 L17.845,58.847 C17.060,58.846 16.304,59.145 15.731,59.683 L15.731,59.683 C15.704,59.711 15.684,59.742 15.657,59.769 L10.193,65.243 C8.684,66.753 6.484,66.998 5.279,65.790 C4.070,64.583 4.314,62.376 5.823,60.866 L7.943,58.742 C6.225,58.493 4.591,57.772 3.244,56.617 C1.185,54.853 -0.000,52.275 -0.000,49.561 L-0.000,30.988 C-0.000,26.947 2.582,23.518 6.181,22.242 L6.181,9.320 C6.181,4.192 10.332,0.034 15.453,0.034 L52.541,0.034 C57.662,0.034 61.813,4.192 61.813,9.320 L61.813,22.242 C65.412,23.518 67.994,26.947 67.994,30.988 L67.994,46.465 C67.994,52.023 64.339,56.725 59.304,58.292 ZM55.631,12.416 C55.631,10.774 54.980,9.199 53.821,8.038 C52.662,6.877 51.090,6.225 49.450,6.225 L18.544,6.225 C16.904,6.225 15.332,6.877 14.173,8.038 C13.014,9.199 12.363,10.774 12.363,12.416 L12.363,22.242 C15.961,23.518 18.544,26.947 18.544,30.988 L18.544,35.632 C18.544,36.042 18.707,36.436 18.996,36.726 C19.286,37.016 19.679,37.179 20.089,37.179 L47.905,37.179 C48.315,37.179 48.708,37.016 48.998,36.726 C49.287,36.436 49.450,36.042 49.450,35.632 L49.450,30.988 C49.450,26.947 52.033,23.518 55.631,22.242 L55.631,12.416 ZM61.813,30.988 C61.813,29.279 60.429,27.893 58.722,27.893 C57.015,27.893 55.632,29.279 55.631,30.988 L55.631,40.275 L55.631,41.822 C55.631,42.233 55.469,42.626 55.179,42.917 C54.889,43.207 54.496,43.370 54.086,43.370 L13.908,43.370 C13.498,43.370 13.105,43.207 12.815,42.917 C12.525,42.626 12.363,42.233 12.363,41.822 L12.363,30.988 C12.362,29.279 10.979,27.893 9.272,27.893 C7.565,27.893 6.181,29.279 6.181,30.988 L6.181,49.561 C6.181,51.270 7.565,52.656 9.272,52.656 L58.722,52.656 C60.429,52.656 61.813,51.270 61.813,49.561 L61.813,30.988 ZM44.814,30.988 L23.180,30.988 C22.149,30.988 21.634,30.472 21.634,29.441 C21.634,28.409 22.149,27.893 23.180,27.893 L44.814,27.893 C45.845,27.893 46.360,28.409 46.360,29.441 C46.360,30.472 45.845,30.988 44.814,30.988 Z"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#999999",
      "font-size": "0.28rem",
      "line-height": "0.48rem"
    }
  }, [_vm._v("暂无评论内容")])]) : _vm._e(), _vm._v(" "), _c('BottomOpenApp', {
    on: {
      "topicToApp": _vm.topicDetail
    }
  }), _vm._v(" "), _c('CommentBox', {
    attrs: {
      "topicInfo": _vm.topicInfo,
      "sid": _vm.sid,
      "discussID": _vm.discussID
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3604396e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/topicColumnDetail.vue
// module id = 290
// module chunks = 1